"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentUser = void 0;
const clerkClient_1 = require("../../server/clerkClient");
const auth_1 = require("./auth");
async function currentUser() {
    const { userId } = (0, auth_1.auth)();
    return userId ? clerkClient_1.clerkClient.users.getUser(userId) : null;
}
exports.currentUser = currentUser;
